import { render, staticRenderFns } from "./ArchiveRenewModal.vue?vue&type=template&id=64da32f4&scoped=true"
import script from "./ArchiveRenewModal.vue?vue&type=script&lang=js"
export * from "./ArchiveRenewModal.vue?vue&type=script&lang=js"
import style0 from "./ArchiveRenewModal.vue?vue&type=style&index=0&id=64da32f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da32f4",
  null
  
)

export default component.exports